import { GoArrowLeft  } from "react-icons/go";
import { CiLaptop ,CiGrid2H,CiRead ,CiCircleCheck    } from "react-icons/ci";
import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
export const Tetraeda = () => {


  return (
      <div>
          <div className="relative isolate overflow-hidden bg-white  lg:overflow-visible lg:px-0">

              <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8  lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
                  <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8">
                      <div className="lg:pr-4">
                          <div className="lg:max-w-lg">
                              <a href={"/company/integrations"} className="text-sm items-center flex font-semibold text-indigo-600"><GoArrowLeft className={"h-5 w-5 mr-2"}/>Zurück</a>
                              <h1 className="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 ">
                                  Tetraeda Planungsinformations- und Beteiligungsserver (PB)
                              </h1>
                              <p className="mt-6 text-sm text-gray-700">
                                  XPläne direkt Anzeigen – Zeigen Sie ab Sofort Ihre XPläne mit dem XPLANUNG24 VIEWER im Planungsinformations- und Beteiligungsserver von Tetraeda an.
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className="-mt-12 -ml-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
                      <img
                          alt=""
                          src={`${process.env.PUBLIC_URL}/integrations/tetraeda/mainImage.png`}
                          className="w-3xl max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-228"
                      />
                  </div>
                  <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 ">
                      <div className="lg:pr-4">
                          <div className="max-w-xl text-sm text-gray-700 lg:max-w-lg">
                              <p>
                                  Ab sofort wird die digitale Bauleitplanung noch transparenter und bürgernäher:<br/>
                                  Mit dem neuen XPLANUNG Viewer können XPläne jetzt direkt im Planungsinformations- und Beteiligungsserver (PB) von tetraeder dargestellt werden – interaktiv, übersichtlich und ohne zusätzliche Software.<br/><br/>
                                  Das bedeutet: Kommunen, Planungsbüros und Beteiligte profitieren von einer durchgängigen Lösung – von der Erarbeitung bis zur Veröffentlichung von XPlanGML-Daten. Der PB-Server wird damit zur zentralen Plattform für digitale Planung, Information und Bürgerbeteiligung.
                              </p>
                              <ul role="list" className="mt-8 space-y-8 text-gray-600">
                                  <li className="flex items-center gap-x-3">
                                      <CiGrid2H aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Nahtlose </strong>  Integration von XPLAN-Daten in bestehende Beteiligungsprozesse
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiLaptop   aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Interaktive Visualisierung</strong>  direkt im Webbrowser – keine Installation nötig
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiRead   aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Einheitliche Darstellung</strong>  komplexer Planwerke
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiCircleCheck   aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Einfache</strong> Ergänzung für bestehendes Planwerke
                                      </span>
                                  </li>
                              </ul>

                              <h2 className="mt-16 text-xl font-bold tracking-tight text-gray-900">So einfach, erweitern Sie Ihren Planungsinformations- und Beteiligungsserver</h2>
                              <p className="mt-6">
                                  <div className={"border bg-gray-300 h-[300px] w-full border-gray-400 my-4  rounded"}>
                                      Video folgt
                                  </div>
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  )
}
